(function($, undefined) {
	
	'use strict';
	var currPage;
    var createMessageBtn;
    var setDeleteMessageBtn;
    var deleteMessageBtn;
    var toggleMessageBtn;
    var pickerWin;
    var pickerIcon;
    var addEventBoxBtn;
    var deleteEmptyEventBoxBtn;
    var addLinkBtn;
    var editEventBoxBtn;
    var addFeaturedBtn;
    
    var updatePickerInput = function(){
        var t = $(this);
        var inp = t.closest(".color-picker-icon-ctn").find("input");
        var name = inp.attr("name");
        
        pickerWin.find(".mg2-color-current").attr("data-inp",name);
    };
    
    var toggleCreateForm = function(){
        var t = $(this);
        if(t.hasClass("logged-nav-item-active")) {
            t.removeClass("logged-nav-item-active");
            $(".create-message-box").slideUp();            
        } 
        else{
            t.addClass("logged-nav-item-active");
            $(".create-message-box").slideDown();                 
        }
    };
    
    var editId;
    var setDeleteInfos = function(){
        var t = $(this);
        
        editId = t.attr("data-editId");
    };
    
    var deleteMessage = function(){
        
        var url = "/action/messages";
        url += "?delete=true";
        url += "&ajax=true";
        url += "&editId="+editId;
        
        ajax(url, function(){
            $("#message"+editId).slideUp();
        }, true);
        
    };
    
    var toggleMessage = function(){
        var t = $(this);        
        var id = t.attr("data-editId");
        var active = t.hasClass("active");
        
        var url = "/action/messages";
        url += "?active="+!active;
        url += "&ajax=true";
        url += "&editId="+id;
        
        ajax(url, function(){
            if(active){
                t.removeClass("active");
            }
            else{
                t.addClass("active");
            }
        }, true);
        
    };
    
    var toggleEventBox = function(e){
        var t = $(this);
        var target = $(e.target);
        var delBtn = t.find(".featured-event-delete");
        if(delBtn.has(e.target).length === 0 && !target.hasClass("featured-event-delete")){
            if(t.attr("data-empty") !== undefined && t.attr("data-empty") === "false"){
                t = $(this).closest(".featured-event-ctn");
            }
            if(!t.hasClass("selected")){
                var inUse = $(".featured-event-ctn.selected");
                var ctn = t.nextAll(".select-featured-ctn:eq(0)");
                if(inUse.length !== 0){
                    if (ctn.find(".create-slider-event-feature").length === 0) {
                        $(".pointer").remove();
                        $(".create-slider-event-feature").slideUp(400, function() {
                            $.when($(this).siblings('div').stop().slideUp()).then(function() {
                                inUse.removeClass("selected");
                                slideBox(t, ctn);
                            });
                        });
                    }
                    else{
                        getBoxPos(t, ctn);
                        inUse.removeClass("selected");
                        t.addClass("selected");                    
                    }
                }
                else{             
                    slideBox(t, ctn);   
                }
            }
            else{
                $(".pointer").remove();
                $(".create-slider-event-feature").slideUp(400, function() {
                    t.removeClass("selected");
                });

            }
        } else{
            $(".pointer").remove();
            if(t.hasClass("selected")){                
                $(".create-slider-event-feature").slideUp(400, function() {});
            }
        }
    };
    
    var slideBox = function(t, ctn){      
        t.addClass("selected");
        var clone = $(".create-slider-event-feature").clone(true);
        $(".create-slider-event-feature").remove();
        ctn.html(clone);
        addPointer(ctn);
        getBoxPos(t, ctn);
        displayedFeaturedEvents = [];
        $(".search-drop-down-choices-inner-ctn").empty();
        $(".lost-tickets-search").val("");
        $(".lost-tickets-search").parent().removeClass("focused");
        $(".create-slider-event-feature").slideDown();
    };
    
    var deleteEmptyBox = function(){
        var t = $(this);
        var ctn = t.parent();
        var id = ctn.attr("data-id");
        var eventId = ctn.attr("data-eventId");
        var deleteLink = false;
        
        var url = "/action/epManageFeatured";        
        url += "?ajax=true";
        if(eventId !== "" && eventId !== "-1" && eventId !== undefined){
            url += "&featureId="+id;
            url += "&deleteLink=true";
            deleteLink = true;
        } else{
            url += "&featureId="+id;
            url += "&delete=true";
        }
        
        ajax(url, function() {
            if(deleteLink){
                ctn.addClass("empty");
                ctn.removeClass("featured-event-ctn-expired");
                ctn.removeAttr("data-eventId");
                ctn.find(".home-event-bg-pic").addClass("home-event-bg-pic-hide");
                ctn.find(".pic-placeholder").addClass("pic-placeholder-hide");
                ctn.find(".home-event-pic-overlay").addClass("home-event-pic-overlay-hide");
                ctn.on("click", toggleEventBox);
                ctn.find(".featured-event-name").empty();
                ctn.find(".featured-event-location").empty();
                ctn.find(".featured-event-date").empty();
                ctn.find(".featured-event-expired").remove();
            }
            else {
                ctn.slideUp(400, function() {
                    ctn.remove();
                    initFeatured();
                });
            }
        }, true);
    };
    
    var addLinkFeatured = function(){
        var f = $(".featured-event-ctn.selected");
        var t = $(this);
        var event = t.closest(".add-slide-ctn").find(".slide-event-selected-ctn .select-profile-from-drop-down[id != 'clone']");
        var eventId = event.attr("id");
        var mediaId = event.attr("data-media-id");
        var id = f.attr("data-id");
        
        var url = "/action/epManageFeatured";
        url += "?ajax=true";
        url += "&featureId=" + id;
        url += "&eventId=" + eventId;
        
        ajax(url, function() {
            var elmt = t.closest(".add-slide-ctn").find(".slide-event-selected-ctn .select-profile-from-drop-down[id != 'clone']");
            f.removeClass("empty");
            f.removeClass("featured-event-ctn-expired");
            f.attr("data-eventId", eventId);
            t.parent().slideUp();
            t.closest(".add-slide-ctn").find(".lost-tickets-search").val("");
            t.closest(".add-slide-ctn").find(".input-ctn").removeClass("focused");
            elmt.slideUp(function() {
                $(this).remove();
            });
            t.closest(".add-slide-ctn").find(".event-select-box").slideUp();
            f.unbind();        
            f.find(".home-event-bg-pic").addClass("home-event-bg-pic-hide");
            f.find(".pic-placeholder").addClass("pic-placeholder-hide");
            f.find(".home-event-pic-overlay").removeClass("home-event-pic-overlay-hide"); 
            if(mediaId !== '0'){
                f.find(".home-event-bg-pic").css("background-image","url('/static/uploaded/EventProfile/"+mediaId+"-profile.jpg')");
                f.find(".home-event-bg-pic").removeClass("home-event-bg-pic-hide");
            }
            else{
                f.find(".pic-placeholder").removeClass("pic-placeholder-hide");                
            } 
            var name = elmt.find(".search-drop-down-one-item-name").html();
            var location = elmt.find(".search-drop-down-one-item-location").html();
            var date = elmt.find(".search-drop-down-one-item-datetime-ctn p").html();
            
            f.find(".featured-event-name").html(name);
            f.find(".featured-event-location").html(location);
            f.find(".featured-event-date").html(date);
            f.find(".featured-event-expired").remove();
        }, true);
    };
    
    var addFeatured = function(){        
        var url = "/action/epManageFeatured";
        url += "?ajax=true";
        url += "&create=true";
        
        ajax(url, function(response) {
            var clone = $("#featured-clone").children().clone(true);
            clone.attr("data-id", response.substring(response.indexOf("- ")+2).trim());
            var qty = $(".featured-main-ctn .featured-event-ctn").length;

            
            $(".featured-main-ctn").append(clone);
            initFeatured();
        }, true);
    };
    
    var initFeatured = function(){
        var l = $(".featured-main-ctn .featured-event-ctn").length;
        var clone = $(".create-slider-event-feature").clone(true);
        clone.removeAttr("style");
        $(".featured-select-copy").html(clone);
        $(".select-featured-ctn").remove();
        $(".featured-event-ctn").removeClass("selected");
        var index = 1;
        $(".featured-main-ctn .featured-event-ctn").each(function() {
            if ((index % 4 === 0 || index === l) && index !== 1) {
                var div = document.createElement("div");
                div.className = "select-featured-ctn";
                $(div).insertAfter($(this));
            }
            index++;
        });
    
    };
    
    var addPointer = function(ctn){
        var div = document.createElement("div");
        div.className = "pointer"; 
        
        ctn.append(div);
    };
    
    var getBoxPos = function(box, ctn){
        var ctnPos = getPosition($(".featured-main-ctn")[0]);
        var pos = getPosition(box[0]);
        var l = pos.x - ctnPos.x - 25;
        var w = box.outerWidth();
        ctn.parent().find(".pointer").css("left", (l + (w/2)) + "px");
    };
    
	var init = function (page) {
		currPage = $(page);
        
        createMessageBtn = $(".create-message-btn");
        createMessageBtn.on("click", toggleCreateForm);
        setDeleteMessageBtn = $(".message-delete");
        setDeleteMessageBtn.on("click", setDeleteInfos);
        deleteMessageBtn = $(".delete-message-btn");
        deleteMessageBtn.on("click", deleteMessage);
        
        toggleMessageBtn = $(".message-power");
        toggleMessageBtn.on("click", toggleMessage);
        
        MG2.ColorPicker.init();
        pickerWin = $("#color-picker-window");
        
        pickerIcon = $(".color-picker-icon"); 
        pickerIcon.on("click", updatePickerInput);
        
        addEventBoxBtn = $(".featured-event-ctn.empty");
        addEventBoxBtn.on("click", toggleEventBox);
        
        editEventBoxBtn = $(".featured-event-edit-btn");
        editEventBoxBtn.on("click", toggleEventBox);
        
        deleteEmptyEventBoxBtn = $(".featured-event-ctn .featured-event-delete");
        deleteEmptyEventBoxBtn.on("click", deleteEmptyBox);
        
        addLinkBtn = $(".save-featured-btn");
        addLinkBtn.on("click", addLinkFeatured);
        
        addFeaturedBtn = $(".add-featured-btn");
        addFeaturedBtn.on("click", addFeatured);
        
        initFeatured();
        
        
	};
	
   	
	$(window).on("load",function(){
        init();
    });
})(jQuery);
			